
<template>
  <header>
    <router-link :to="homeLink">
      <img class="logo" src="static/chc-logo.png" alt="Cars Helping Charities">
    </router-link>
    <div class="account-wrapper">
      <ul>
        <li v-if="!noLogin && user.authenticated" class="account-toggle">Welcome, {{ user.first_name }} <span class="icon fas fa-caret-down" aria-hidden="true"></span>
          <ul class="account-menu">
            <li><router-link to="/app/reset-password">Reset Password</router-link></li>
            <li @click="logout"><a href="#">Logout</a></li>
          </ul>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import auth from '@/auth'

export default {
  name: 'ChcHeader',
  data () {
    return {
      user: auth.user
    }
  },
  props: {
    noLogin: {
      default: false
    }
  },
  methods: {
    logout () {
      auth.logout()
    }
  },
  computed: {
    homeLink () {
      return this.user.authenticated ? '/app/' : '/login'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../style/variables";
/* ============= HEADER ============ */
header {
  margin: 0;
  padding: 1rem;
  background-color: $lt-grey;
  background-image: radial-gradient(circle, #FFFDFA 150px, #AAB5DC);
  position: relative;
  .logo {
    display: block;
    max-width: 400px;
    margin: auto;
  }
}
.account-wrapper {
  position: absolute;
  top: .65rem;
  right: 1rem;
  ul {
    margin: 0;
    padding: 0;
  }
  .account-toggle {
    text-align: right;
    list-style-type: none;
    margin: 0;
    padding: .35rem 0;
    color: $dark-purple;
    .icon {
      color: $dark-purple;
    }
    .account-menu {
      display: none;
      position: absolute;
      top: 1.7rem;
      right: 0;
      background-color: #ffffff;
      border-top: 2px solid $yellow;
      border-radius: 0 0 .25rem .25rem;
      box-shadow: 0 3px 10px $dark-grey;
      padding: .75rem .75rem 0 .75rem;
      list-style-type: none;
      margin: 0;
      width: 140px;
      z-index: 100;
      text-align: left;
      &:before {
        content: '';
        display: block;
        height: 3px;
        position: absolute;
        top: -5px;
        width: 100%;
        left: -1px;
      }
      li {
        margin: 0;
        text-align: left;
      }
      a {
        margin-bottom: .75rem;
        display: inline-block;
      }
    }
    &:hover {
      .icon {
        transform: rotate(180deg);
      }
      .account-menu {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ChcHeader.vue